// Add your custom JS here.

(function($) {

  //to-top
  $(function() {
      let showFlag = false;
      const topBtn = $('.to-top');    
      topBtn.css('bottom', '-100px');
      //スクロールが100に達したらボタン表示
      $(window).on('scroll', function () {
          if ($(this).scrollTop() > 100) {
              if (showFlag == false) {
                  showFlag = true;
                  topBtn.stop().animate({'bottom' : '0'}, 200); 
              }
          } else {
              if (showFlag) {
                  showFlag = false;
                  topBtn.stop().animate({'bottom' : '-100px'}, 200); 
              }
          }
      });

      topBtn.on('click', function(){
        $('body,html').animate({
          scrollTop: 0},500);
          return false;
      });

  });




// スムーススクロール ページ内
document.querySelectorAll('a[href*="#"]').forEach(anchor => {
  anchor.addEventListener('click', function(e) {
    const href= $(this).attr("href").replace(/.*#/, '');
    const targetId = '#' + href;
    const targetElement = document.querySelector(targetId);

    if (targetElement) {
      e.preventDefault(); // デフォルトの挙動を無効化
      // ヘッダーの高さを考慮
      const headerHeight = document.getElementById("main-nav").offsetHeight;
      const targetPosition = targetElement.getBoundingClientRect().top + window.pageYOffset - headerHeight;
      
      window.scrollTo({
        top: targetPosition,
        behavior: 'smooth' // スムーススクロール
      });

    }
  });
});

// スムーススクロール ページ外
window.addEventListener('load', () => {
  // URLにハッシュ(#)があるか確認
  if (window.location.hash) {
    const targetId = window.location.hash;
    const targetElement = document.querySelector(targetId);
    
    if (targetElement) {
      // 読み込み完了後に少し遅延を入れると確実
      setTimeout(() => {
        const headerHeight = document.getElementById("main-nav").offsetHeight;
        const targetPosition = targetElement.getBoundingClientRect().top + window.pageYOffset - headerHeight;
        
        window.scrollTo({
          top: targetPosition,
          behavior: 'smooth'
        });
      }, 100); // 100ms遅延

    }
  }
});


// リンククリックでoffcanvasを閉じる
$(function() {
  const myOffcanvas = $('#navbarNavOffcanvas');
  const offcanvasLink = myOffcanvas.find('.nav-link:not(.dropdown-toggle)');
  offcanvasLink.on('click', function(){
    myOffcanvas.offcanvas('hide');
  })
});



})(jQuery);